module.exports = __webpack_public_path__ + "img/AL275-1.00acc075.png";